import React from 'react'

const SEVERITY_COLORS = {
  high: '#e85d5d',
  medium: '#e89a5d',
  low: '#3b82c4',
  info: '#3b82c4',
}

export function AlertsList({ alerts, onAlertClick }) {
  if (!alerts || alerts.length === 0) {
    return <div style={styles.empty}>No alerts — all looks good.</div>
  }
  return (
    <div style={styles.list}>
      {alerts.map((alert, i) => (
        <button
          key={i}
          style={styles.item}
          onClick={() => onAlertClick && onAlertClick(alert)}
        >
          <span
            style={{
              ...styles.dot,
              background: SEVERITY_COLORS[alert.severity] || SEVERITY_COLORS.info,
            }}
          />
          <div>
            <div style={styles.message}>{alert.message}</div>
          </div>
        </button>
      ))}
    </div>
  )
}

const styles = {
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  item: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    padding: '8px 0',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%',
    borderBottom: '1px solid var(--border)',
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    marginTop: 3,
    flexShrink: 0,
  },
  message: {
    fontSize: 12,
    color: 'var(--text-primary)',
  },
  empty: {
    fontSize: 12,
    color: 'var(--text-secondary)',
  },
}
